import React from 'react';

const Objectives = () => {
  return (
    <section id="objectives" className="mb-5 objectives">
      <h2 className="heading">Objectives</h2>
      <ul>
        <li>To promote social welfare by addressing the needs of vulnerable groups, including families, women, children, and persons with disabilities.</li>
        <li>To provide support during crises such as unemployment, underemployment, old age, illness, and other unforeseen personal or economic hardships.</li>
        <li>To deliver essential services that enhance well-being, resilience, and self-reliance within communities.</li>
        <li>To mobilize and coordinate emergency relief efforts in response to natural or man-made disasters, ensuring timely and effective assistance.</li>
        <li>To build and maintain infrastructure for service delivery, outreach, and community engagement.</li>
        <li>To empower women and children through education, health, livelihood support, and protection services.</li>
        <li>To collaborate with government agencies, NGOs, and community stakeholders to maximize the reach and impact of social welfare initiatives.</li>
        <li>To advocate for inclusive policies and systems that uphold the rights and dignity of marginalized and vulnerable populations.</li>
      </ul>
    </section>
  );
};

export default Objectives;
